import React from 'react';
import { Form, Field } from 'react-final-form';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Table, Spinner } from 'react-bootstrap';
import { SearchAlt } from '@styled-icons/boxicons-regular/SearchAlt';
import { CommentEdit } from '@styled-icons/boxicons-regular/CommentEdit';

//Actions
import { pesquisa, eventoselecionado } from '../../../../actions/eventos/eventos';

//Components
import { campotexto } from '../../../../components/forms/campos/campos';


class Evento extends React.Component {

    handleSubmit = (form) => {
        const dados = {
            ...form,
            idpromotora: this.props.idpromotora
        }
        this.props.pesquisa(dados);
    }

    handleEditar = (item) => {
        this.props.eventoselecionado(item);
        this.props.handleCloseModal();
        this.props.handleEditFormEvento();
    }
    
    render() {        
        return (
            <Form
            onSubmit={this.handleSubmit}
            render={({ submitting, pristine, form, handleSubmit, submitSucceeded }) => (                
                <form onSubmit={handleSubmit}>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Edição</th>
                                <th>Descrição</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <Field type="tel" name='edicao' component={campotexto} placeholder="Ex. 2020" />
                                    </td>
                                <td><Field type="text" name='sigladoevento' component={campotexto} /></td>
                                <td>
                                    <Button type="submit">
                                        <SearchAlt size="30" disabled={pristine || submitting} />
                                        {this.props.pendingTasks?
                                        <Spinner animation="border"  />
                                        :
                                        null
                                        }
                                    </Button>
                                </td>
                            </tr>                    
                        </tbody>
                    </Table>                    
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                            <th>#</th>
                            <th>Edição</th>
                            <th>Nome</th>
                            <th>Editar</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.eventos.length?this.props.eventos.map(itens => {
                                return (
                                    <tr key={itens.idevento}>
                                        <td>{itens.idevento}</td>
                                        <td>{itens.edicao}</td>
                                        <td>{itens.sigladoevento}</td>
                                        <td>
                                            <CommentEdit style={{cursor: "pointer"}} onClick={() => this.handleEditar(JSON.stringify(itens))} size="35" />
                                        </td>
                                    </tr>  
                                )
                            })
                            :
                            null
                            }                  
                        </tbody>
                    </Table>
                </form>
            )}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        eventos: state.reducerPesquisaEventos,
        pendingTasks: state.pendingTasks        
    }
}

export default connect(mapStateToProps,{pesquisa, eventoselecionado})(withRouter(Evento));